import type { SetOptional } from 'type-fest'
import { z } from 'zod'

import {
  toUserDisplayModel,
  type UserDisplayModelComputedProperties,
  UserDisplayModelSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const PersonSchema = UserDisplayModelSchema.extend({
  avatarUrl: z.string().optional(),
})

export type Person = ZodInfer<typeof PersonSchema>

export const toPerson = ({
  avatarUrl,
  ...person
}: SetOptional<Person, UserDisplayModelComputedProperties>) => {
  return {
    ...toUserDisplayModel(person),
    avatarUrl,
  }
}
